export default __webpack_public_path__ + "static/sandbox-client-process-c02f852856f87e2b4f17133e79786ad7.svg";